import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getRioHostNames from './fetchAllHostNames';
import { HOSTNAME, NULL, UNDEFINED } from '../../types';
import { ls, Logger } from '../../utils';
import GrpcRioClient from '../grpc';
export var HostNameClient = /*#__PURE__*/_createClass(function HostNameClient() {
  var _this = this;
  _classCallCheck(this, HostNameClient);
  _defineProperty(this, "primaryHostName", void 0);
  _defineProperty(this, "secondaryHostName", void 0);
  // validate hostname using CSID and session id stored in local storage
  // if not found, then fetch it and save
  _defineProperty(this, "validateLocalStorageSessionId", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retries) {
      var primaryHostName, secondaryHostName, _yield$getRioHostName;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            primaryHostName = ls.getItem(HOSTNAME.PRIMARY_HOST_NAME), secondaryHostName = ls.getItem(HOSTNAME.SECONDARY_HOST_NAME);
            if (!(GrpcRioClient.isLastSessionActive && (primaryHostName && primaryHostName !== UNDEFINED && primaryHostName !== NULL || secondaryHostName && secondaryHostName !== UNDEFINED && secondaryHostName !== NULL))) {
              _context.next = 5;
              break;
            }
            Logger.info('hostnames already exist');
            _context.next = 12;
            break;
          case 5:
            _context.next = 7;
            return getRioHostNames(retries);
          case 7:
            _yield$getRioHostName = _context.sent;
            primaryHostName = _yield$getRioHostName.primaryHostName;
            secondaryHostName = _yield$getRioHostName.secondaryHostName;
            if (primaryHostName) {
              ls.setItem(HOSTNAME.PRIMARY_HOST_NAME, primaryHostName);
            }
            if (secondaryHostName) {
              ls.setItem(HOSTNAME.SECONDARY_HOST_NAME, secondaryHostName);
            }
          case 12:
            Logger.info('host names:', primaryHostName, secondaryHostName);
            _this.primaryHostName = primaryHostName;
            _this.secondaryHostName = secondaryHostName;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});
export default HostNameClient;